import { queryOptions } from '@tanstack/react-query';
import type {
  ListMutualDuosData,
  ListMutualDuosResponse,
} from 'generated/openapi';

import { PrivateApi } from '@/shared/api/httpClient';
import type { ReplacePathParams } from '@/shared/utils/pathParams';

export interface ListMutualDuosKeyParams {
  userId: string;
  pageNumber?: number;
  pageSize?: number;
}

const listMutualDuosUrl = (
  userId: string,
): ReplacePathParams<ListMutualDuosData['url']> =>
  `users/${userId}/duos/mutual`;

export const listMutualDuosKey = ({
  userId,
  pageNumber,
  pageSize,
}: ListMutualDuosKeyParams) =>
  ['mutual-duos', userId, { pageNumber, pageSize }] as const;

export const listMutualDuosOptions = (params: ListMutualDuosKeyParams) =>
  queryOptions({
    queryKey: listMutualDuosKey(params),
    queryFn: async ({ signal }) =>
      PrivateApi.get(listMutualDuosUrl(params.userId), {
        signal,
        searchParams: {
          ...(params.pageNumber !== undefined && {
            pageNumber: params.pageNumber,
          }),
          ...(params.pageSize !== undefined && { pageSize: params.pageSize }),
        },
      }).json<ListMutualDuosResponse>(),
  });
